import {createSelector} from 'reselect';
import props from './props';

export default createSelector(
    props.app.device_os,
    (device_os) => {
        return {
            device_os
        }
    }
)